import { render, staticRenderFns } from "./privateProducts.vue?vue&type=template&id=63f54dc1"
import script from "./privateProducts.vue?vue&type=script&lang=js"
export * from "./privateProducts.vue?vue&type=script&lang=js"
import style0 from "./privateProducts.vue?vue&type=style&index=0&id=63f54dc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports